module.exports = __webpack_public_path__ + "img/vertical_6_6_8017.015874e5.png";